const LocalStorageHelper = {
  setItem: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
  },

  getItem: (key) => {
    try {
      const value = localStorage.getItem(key)
      return value ? JSON.parse(value) : null
    } catch (ex) {
      return null
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key)
  }
}

export default LocalStorageHelper
